import superagent from 'superagent'
import isNil from 'lodash/isNil'
import { __API_URI__ } from '../utils/config'

export const markerTypes25Set = markerTypes => ({
  type: 'MARKER_TYPES_25_SET',
  payload: markerTypes
})

export const markerTypes25FetchRequest = () => (dispatch, getState, token) => {

  const markerTypes25 = getState().markerTypes25
  return (
    // !isNil(markerTypes25) && markerTypes25.length > 0 ? Promise.resolve(markerTypes25) :
    new Promise(resolve => {
      superagent
        .get(`${__API_URI_2__}/MarkerType/Get?activity=255&folder=small25`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (!res) return resolve(null)
          if (err) {
            if (err.status == 401) {
              return resolve(err.status)
            }
            return resolve(null)
          }
          dispatch(markerTypes25Set(res.body))
          resolve(res.body)
        })
    }))
}
